import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { MenuItems } from '../enums/MenuItems'
import LayoutSingleViewFullWidth from '../uiV2/common/layout/LayoutSingleViewFullWidth'
import Section from '../components/Section'
import Tabs from '../components/Tabs'
import KitConversationsTab from '@/components/kit/KitConversationsTab'
import KitScreeningJobsTab from '@/components/kit/KitScreeningJobsTab'
import KitJobAdsTab from '@/components/kit/KitJobAdsTab'
import KitCoreSignalJobsTab from '@/components/kit/KitCoreSignalJobsTab'
import { JobsApiTestTab } from './Jobs'

const KIT_TAB_LABELS = [
    'Conversations',
    'Screening Jobs',
    'Job Ads',
    'Jobs API Test',
    'Core Signal Jobs',
] as const

const slugify = (label: string) =>
    label
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')

export default function Kit(): React.JSX.Element {
    const [searchParams, setSearchParams] = useSearchParams()
    const tabParam = searchParams.get('tab') || ''

    const slugToIndex = useMemo(() => {
        const map = new Map<string, number>()
        KIT_TAB_LABELS.forEach((label, index) => map.set(slugify(label), index))
        return map
    }, [])

    const indexToSlug = useMemo(
        () => KIT_TAB_LABELS.map((label) => slugify(label)),
        [],
    )

    const activeIndex = useMemo(() => {
        const idx = slugToIndex.get(tabParam)
        return idx !== undefined ? idx : 0
    }, [slugToIndex, tabParam])

    return (
        <LayoutSingleViewFullWidth activeMenuItem={MenuItems.Kit}>
            <Section title="Kit">
                <Tabs
                    unmountInactiveTabs
                    activeIndex={activeIndex}
                    onTabChange={(idx) => {
                        const nextSlug = indexToSlug[idx] || indexToSlug[0]
                        const newParams = new URLSearchParams(searchParams)
                        newParams.set('tab', nextSlug)
                        setSearchParams(newParams, { replace: true })
                    }}
                    tabs={[
                        {
                            label: KIT_TAB_LABELS[0],
                            content: <KitConversationsTab />,
                        },
                        {
                            label: KIT_TAB_LABELS[1],
                            content: <KitScreeningJobsTab />,
                        },
                        {
                            label: KIT_TAB_LABELS[2],
                            content: <KitJobAdsTab />,
                        },
                        {
                            label: KIT_TAB_LABELS[3],
                            content: <JobsApiTestTab />,
                        },
                        {
                            label: KIT_TAB_LABELS[4],
                            content: <KitCoreSignalJobsTab />,
                        },
                    ]}
                />
            </Section>
        </LayoutSingleViewFullWidth>
    )
}
